import React from 'react';

const LockRedIcon = () => (
    <svg
        width="24"
        height="24"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
        d="M6.49951 6.19995L6.49951 4.79997C6.49951 3.25359 7.7531 2 9.29948 2V2C10.033 2 11.6 2.4 12 4"
        stroke="red"
        strokeLinecap="round"
        />
        <path
        d="M15.5996 14.3998V7.79995C15.5996 6.9163 14.8833 6.19995 13.9996 6.19995H4.59976C3.7161 6.19995 2.99976 6.91629 2.99976 7.79995V14.3998C2.99976 15.2835 3.7161 15.9998 4.59976 15.9998H13.9996C14.8833 15.9998 15.5996 15.2835 15.5996 14.3998Z"
        stroke="red"
        />
        <path
        d="M9.99987 11.3333C9.99987 10.9037 9.65165 10.5555 9.2221 10.5555C8.79255 10.5555 8.44434 10.9037 8.44434 11.3333C8.44434 11.7628 8.79255 12.111 9.2221 12.111C9.65165 12.111 9.99987 11.7628 9.99987 11.3333Z"
        fill="#9199B1"
        stroke="red"
        />
    </svg>
);

export default LockRedIcon;


